import {
  ADD_COMPANY,
  UPDATE_COMPANY,
  SET_COMPANIES,
  SET_SELECTED_COMPANY,
  UPDATE_COMPANY_NAME,
  DELETE_COMPANY,
} from "../types/company";

export const addCompany = (params) => ({
  type: ADD_COMPANY,
  payload: params,
});

export const updateCompany = (params) => ({
  type: UPDATE_COMPANY,
  payload: params,
});

export const updateCompanyName = (params) => ({
  type: UPDATE_COMPANY_NAME,
  payload: params,
});
export const deleteCompany = (params) => ({
  type: DELETE_COMPANY,
  payload: params,
});

export const setCompanies = (params) => ({
  type: SET_COMPANIES,
  payload: params,
});

export const setSelectedCompany = (params) => ({
  type: SET_SELECTED_COMPANY,
  payload: params,
});
